export const USER_GROUP_NAME = "User";
